import React from "react"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import {useBranding} from "@irati/brand"
import Card from "@irati/ui/src/Layout/Card"
import {StatementItem} from "@irati/types"
import Markdown from "@irati/ui/src/Markdown"
import {useStatementItemDetails} from "@irati/wallet/hooks/statementItems"
import styled from "styled-components"
import Spacing from "@irati/ui/src/Spacing"
import PrimaryDetails from "../PrimaryDetails"
import ExpanderItem from "../ExpanderItem"
import Wrapper from "../SecondaryDetails/Wrapper"
import {Container} from "../SecondaryDetails/styled/Item"

interface Props {
  statementItem: StatementItem
  customDetails?: JSX.Element
}

const StyledCard = styled(Card)`
  margin-bottom: 20px;
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

const StyledMarkdown = styled(Markdown)`
  p {
    margin: 0;
  }
`

export const SimpleStatement = ({statementItem, customDetails}: Props) => {
  const {secondaryDetails, primaryDetails} = useStatementItemDetails(statementItem)
  const {isBrandLogo, image} = useImage(statementItem.content?.image)
  const prime = {...primaryDetails, image}
  return secondaryDetails || customDetails ? (
    <Spacing marginBottom={4}>
      <ExpanderItem
        PrimaryElement={() => <PrimaryDetails imgHeightAuto={isBrandLogo} data={prime} />}
        SecondaryElement={
          <Wrapper>
            <Container>
              {secondaryDetails && <StyledMarkdown source={secondaryDetails} componentProps={{body: {small: true}}} />}
              {!!customDetails && customDetails}
            </Container>
          </Wrapper>
        }
      />
    </Spacing>
  ) : (
    <StyledCard medium noBorder>
      <PrimaryDetails imgHeightAuto={isBrandLogo} data={prime} />
    </StyledCard>
  )
}

function useImage(image?: string): {image: string; isBrandLogo: boolean} {
  const brandLogo = useBranding()?.businessLogoUrl

  if (image === "PERKBOX") return {image: perkboxLogo, isBrandLogo: true}
  if (image === "BRAND") return {image: brandLogo ?? perkboxLogo, isBrandLogo: true}
  return image ? {image, isBrandLogo: false} : {image: perkboxLogo, isBrandLogo: true}
}
